import { ConnectionType } from '@/features/print/constants'
import { FormKeys } from '@/features/settings/components/AddPrinterModal/form/constants'
import { z } from 'zod'

export const schema = z
    .object({
        [FormKeys.ConnectionType]: z
            .nativeEnum(ConnectionType)
            .nullable()
            .transform((value, ctx): ConnectionType => {
                if (value === null) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        fatal: true,
                    })

                    return z.NEVER
                }

                return value
            }),
        [FormKeys.IpAddress]: z.string().ip().optional(),
    })
    .superRefine((data, ctx) => {
        if (data[FormKeys.ConnectionType] === ConnectionType.Network && !data[FormKeys.IpAddress]) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: [FormKeys.IpAddress],
            })
        }
    })
